
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipment/[equipment_id]/diagrams/[id]",
      function () {
        return require("private-next-pages/equipment/[equipment_id]/diagrams/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipment/[equipment_id]/diagrams/[id]"])
      });
    }
  